export default "__VITE_ASSET__RJ3BHRSQ__"